const contentModes = {
    nakiStandard: 0,
    whitelistMode: 1,
    certified: 2,
};

export default contentModes;
